import React from 'react';
/**
 * DjayAvatar part — eyes per emotion.
 * Verbatim extraction of the former `renderEyes()`. Add a new emotion's eye
 * shape by adding a `case` here (and the matching token in `DjayEmotion`).
 */
import type { DjayEmotion } from '../types';
export function Eyes({
  emotion,
  glow = false,
  glowColor = '#FDE68A'
}: {
  emotion: DjayEmotion;
  glow?: boolean;
  glowColor?: string;
}) {
  switch (emotion) {
    case 'sleeping':
      return <g className="djay-eyes" data-id="element-3310" data-mp="w9q09cxfotlx">
          <path d="M60 102 Q70 108 80 102" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3311" data-mp="10d5u61i4cfux" />
          <path d="M120 102 Q130 108 140 102" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3312" data-mp="rcr7axpiaspb" />
        </g>;
    case 'celebrating':
      return <g className="djay-eyes" data-id="element-3313" data-mp="3c400gvsb2fh5">
          <path d="M60 105 Q70 95 80 105" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3314" data-mp="3c0vq1go8yni1" />
          <path d="M120 105 Q130 95 140 105" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3315" data-mp="30b6iggnfgoy8" />
        </g>;
    case 'encouraging':
      return <g className="djay-eyes" data-id="element-3316" data-mp="3na1mk5bj3l08">
          <path d="M60 100 Q70 95 80 100" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3317" data-mp="3n8zzt3l5ha2o" />
          <path d="M120 100 Q130 95 140 100" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3318" data-mp="v05ou9asvde" />
        </g>;
    case 'proud':
      return <g className="djay-eyes" data-id="element-3319" data-mp="at6617fghtg5">
          <path d="M60 100 Q70 90 80 100" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3320" data-mp="aqa5dbc84qo0" />
          <path d="M70 92 L72 96 L76 96 L73 99 L74 103 L70 100 L66 103 L67 99 L64 96 L68 96 Z" fill="#FBBF24" data-id="element-3321" data-mp="cykuyxqbofi7" />
          <path d="M120 100 Q130 90 140 100" stroke="#1E293B" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-3322" data-mp="mufjual536tf" />
          <path d="M130 92 L132 96 L136 96 L133 99 L134 103 L130 100 L126 103 L127 99 L124 96 L128 96 Z" fill="#FBBF24" data-id="element-3323" data-mp="wl0syryfvtql" />
        </g>;
    default:
      {
        let pupilXOffset = 0,
          pupilYOffset = 0,
          pupilSize = 3.5,
          showSparkles = true;
        if (emotion === 'thinking') {
          pupilXOffset = 3;
          pupilYOffset = -3;
        } else if (emotion === 'pointing') {
          pupilXOffset = 5;
        } else if (emotion === 'surprised') {
          pupilSize = 2;
          showSparkles = false;
        }
        return <g className="djay-eyes" data-id="element-3324" data-mp="3cdzevh28opgg">
          {glow && <g className="djay-eye-glow" aria-hidden="true" data-id="element-3325" data-mp="34tfekoldzdhp">
              <circle cx="70" cy="100" r="15" fill={glowColor} fillOpacity="0.5" data-id="element-3326" data-mp="301nla6auitnv" />
              <circle cx="130" cy="100" r="15" fill={glowColor} fillOpacity="0.5" data-id="element-3327" data-mp="2v0gd464sjsgo" />
            </g>}
          <ellipse cx="70" cy="100" rx="10" ry="12" fill="white" data-id="element-3328" data-mp="3np5fs9lhw5uj" />
          <ellipse cx={72 + pupilXOffset} cy={102 + pupilYOffset} rx="6" ry="7" fill="#475569" data-id="element-3329" data-mp="3itgdhyi3cauj" />
          <circle cx={73 + pupilXOffset} cy={103 + pupilYOffset} r={pupilSize} fill="#0F172A" data-id="element-3330" data-mp="38uh2wadrm54w" />
          {showSparkles && <circle cx={76 + pupilXOffset} cy={99 + pupilYOffset} r={emotion === 'excited' ? 3.5 : 2.5} fill="white" data-id="element-3331" data-mp="1xesjfszpzo8u" />}
          {showSparkles && <circle cx={69 + pupilXOffset} cy={105 + pupilYOffset} r="1" fill="white" fillOpacity="0.7" data-id="element-3332" data-mp="3qzyeasuab7uy" />}
          <ellipse cx="130" cy="100" rx="10" ry="12" fill="white" data-id="element-3333" data-mp="3h93l14imf800" />
          <ellipse cx={132 + pupilXOffset} cy={102 + pupilYOffset} rx="6" ry="7" fill="#475569" data-id="element-3334" data-mp="8u3fy3y71a7f" />
          <circle cx={133 + pupilXOffset} cy={103 + pupilYOffset} r={pupilSize} fill="#0F172A" data-id="element-3335" data-mp="dsepedkktip4" />
          {showSparkles && <circle cx={136 + pupilXOffset} cy={99 + pupilYOffset} r={emotion === 'excited' ? 3.5 : 2.5} fill="white" data-id="element-3336" data-mp="3tff6qk5xf00" />}
          {showSparkles && <circle cx={129 + pupilXOffset} cy={105 + pupilYOffset} r="1" fill="white" fillOpacity="0.7" data-id="element-3337" data-mp="2oiv41fztmtn0" />}
        </g>;
      }
  }
}